import React, {
  ReactElement,
  useEffect,
  useState,
} from 'react';
import {Entity} from '../../types/entities/Entity';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import {AvatarGroup, Checkbox, Chip, List, Stack, Switch, TextField, Typography} from '@mui/material';
import {ContactMailRounded, InfoRounded} from "@mui/icons-material";
import Box from "@mui/material/Box";
import whatsapp from '../../assets/icons/whatsapp.svg';
import Tooltip from "@mui/material/Tooltip";


type Props<T extends Entity> = {
  item: any;
  index: number;
  readonly?: boolean;
  onSubmit: () => void;
  onChangeCheck: (id: any, value: any) => void;
  onChangeMessage: (id: string | number, text: string) => void;
};

export const SendModificationListItem = <T extends Entity>({
                                                             item,
                                                             index,
                                                             onChangeCheck,
                                                             onChangeMessage,
                                                             onSubmit,
                                                             readonly,
                                                           }: Props<T>): ReactElement => {
  const [checked, setChecked] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {

    const newChecked: { [key: string]: boolean } = {};
    item.modifications.forEach((modification: any) => {
      if (modification.id) {
        newChecked[modification.id] = true;
      }
    });

    setChecked(newChecked);

  }, []);

  const hasVehicles = item?.service_provider?.vehicles?.length > 0;

  return (
    <>
      <ListItem
        key={index}
        secondaryAction={<></>}
        disablePadding
        sx={{
          background: '#f3f3f3',
          borderRadius: '10px',
          marginTop: '10px',
        }}
      >
        <ListItem
          sx={{
            padding: '10px',
          }}
        >
          <ListItemText
            primary={
              <React.Fragment>
                <Stack
                  direction={'row'}
                  gap={1}
                  alignItems={'center'}
                  sx={{
                    marginBottom: '10px',
                  }}
                >
                  {item?.service_provider?.whatsapp ? (
                    <Box sx={{
                      width: "30px"
                    }}>
                      <img src={whatsapp} alt="Whatsapp" />
                    </Box>
                  ) : (
                    <ContactMailRounded color={'primary'} />
                  )}

                  <Typography sx={{ fontWeight: 'bold' }}>
                    {item?.service_provider?.name}:
                  </Typography>
                  <Stack gap={1} direction={'row'} flexWrap={'wrap'} alignItems={'flex-start'}>
                    {item.contacts.map((contact: any) => {
                      return (
                        <Chip label={<>
                          <Stack direction={'row'} gap={1}>
                            <Typography sx={{fontWeight: 'bold'}}>
                              {contact?.name}
                            </Typography>
                            <Typography color={'#666'}>
                              ({item?.service_provider?.whatsapp?contact?.phone:contact?.email})
                            </Typography>
                          </Stack>
                        </>}/>
                      );
                    })}
                  </Stack>
                </Stack>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                {item.modifications.map((providerModifications:any, providerModificationsIndex:any)=>{

                  console.log(providerModifications);

                    return (
                      <>
                        <List
                          sx={{
                            background: '#fff',
                            borderRadius: '8px',
                            marginBottom: '8px',
                            borderBottom: '1px solid #e7e7e7',
                          }}
                        >
                          <ListItem
                            key={providerModificationsIndex}
                            sx={{
                              paddingTop: '0px',
                              paddingBottom: '0px',
                            }}
                          >
                            <ListItemText
                              primary={
                                <React.Fragment>
                                  <Stack gap={1}>
                                    <Stack
                                      direction={'row'}
                                      alignItems={'center'}
                                      gap={1}
                                    >
                                      <div
                                        className={
                                          'flex items-center justify-between w-full'
                                        }
                                      >
                                        <Stack gap={1}>
                                          {item?.contact_has_more_provider && (
                                            <>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Szolgáltató:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      item?.service_provider
                                                        ?.name,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                            </>
                                          )}

                                          {(providerModifications?.type ===
                                            'airport-transfer' ||
                                            providerModifications?.type ===
                                              'transfer') && (
                                            <>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Típus:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.type,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Szolgáltatás:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.service,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Program:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.activity,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Includes:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.includes,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Csoport:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.group,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Létszám:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.size,
                                                  }}
                                                ></Typography>
                                              </Stack>

                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                                sx={{

                                                }}
                                              >
                                                <Typography>Dátum:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.date,
                                                  }}
                                                ></Typography>
                                                {providerModifications?.is_after_midnight && (
                                                 <Typography
                                                   variant={'caption'}
                                                 sx={{
                                                   color: '#951515'
                                                 }}>
                                                   Technikailag ez még az előző nap (<b>{providerModifications?.date_minus_day}</b>)
                                                 </Typography>
                                                )}
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Pickup:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.pickup_time,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Kezdés:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.start_time,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              {providerModifications?.type ===
                                                'airport-transfer' && (
                                                <Stack
                                                  direction={'row'}
                                                  alignItems={'center'}
                                                  gap={1}
                                                >
                                                  <Typography>
                                                    Járatszám:
                                                  </Typography>
                                                  <Typography
                                                    sx={{ fontWeight: 'bold' }}
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        providerModifications
                                                          ?.value?.flight,
                                                    }}
                                                  ></Typography>
                                                </Stack>
                                              )}
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Találkozási pont:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.meeting_place,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              {hasVehicles && (
                                                <Stack direction={'row'} alignItems={'center'} gap={1}>
                                                  <Typography>
                                                    Jármű:
                                                  </Typography>
                                                  <Typography sx={{fontWeight: 'bold'}}
                                                              dangerouslySetInnerHTML={{__html: providerModifications?.value?.vehicle}}
                                                  >
                                                  </Typography>
                                                </Stack>
                                              )}
                                            </>
                                          )}

                                          {(providerModifications?.type ===
                                            'event-staff' ||
                                            providerModifications?.type ===
                                              'event-staff-airport-transfer') && (
                                            <>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Típus:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.type,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Fellépő:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.event_staff,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Program:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.activity,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Includes:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.includes,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Műsor:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.service,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Csoport:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.group,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Létszám:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.size,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Dátum:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.date,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Érkezés:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications?.type ===
                                                      'event-staff-airport-transfer'
                                                        ? providerModifications
                                                            ?.value
                                                            ?.pickup_arrival_time
                                                        : providerModifications
                                                            ?.value
                                                            ?.arrival_time,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Kezdés:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications?.type ===
                                                      'event-staff'
                                                        ? providerModifications
                                                            ?.value?.start_time
                                                        : providerModifications
                                                            ?.value
                                                            ?.pickup_time,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                            </>
                                          )}

                                          {providerModifications?.type ===
                                            'default' && (
                                            <>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Típus:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.type,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Szolgáltatás:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.service,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Program:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.activity,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Includes:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.includes,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Csoport:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.group,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Létszám:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.size,
                                                  }}
                                                ></Typography>
                                              </Stack>

                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Dátum:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.date,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>Kezdés:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      providerModifications
                                                        ?.value?.start_time,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                            </>
                                          )}

                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>Helyszín:</Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  providerModifications?.type ===
                                                  'event-staff-airport-transfer'
                                                    ? providerModifications
                                                        ?.value?.meeting_place
                                                    : providerModifications
                                                        ?.value?.venue,
                                              }}
                                            ></Typography>
                                          </Stack>

                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>Guide:</Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  providerModifications?.value
                                                    ?.guide,
                                              }}
                                            ></Typography>
                                          </Stack>


                                        {/*  <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>Megjegyzés:</Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                providerModifications?.value
                                                  ?.guide,
                                              }}
                                            ></Typography>
                                          </Stack>*/}

                                          {/* <Stack direction={'row'} alignItems={'center'} gap={1}>
                                            <Typography>
                                              Ár:
                                            </Typography>
                                            <Typography sx={{fontWeight: 'bold'}}
                                                        dangerouslySetInnerHTML={{__html: providerModifications?.value?.final_cost}}
                                            >
                                            </Typography>
                                          </Stack>*/}

                                          {(providerModifications?.value?.custom_fields && providerModifications?.value?.custom_fields.length ) ? (
                                            <>
                                              {providerModifications.value.custom_fields.map(
                                                (customField: any) => {
                                                  return (
                                                    <Stack
                                                      direction={'row'}
                                                      alignItems={'center'}
                                                      gap={1}
                                                    >
                                                      <Typography>
                                                        {
                                                          customField?.column
                                                            ?.name
                                                        }
                                                        :
                                                      </Typography>
                                                      {(customField?.column
                                                          ?.type === 'float' ||
                                                        customField?.column
                                                          ?.type ===
                                                        'string') && (
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 'bold',
                                                          }}
                                                        >
                                                          {customField?.value}
                                                        </Typography>
                                                      )}
                                                      {customField?.column
                                                        ?.type === 'boolean' && (
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 'bold',
                                                          }}
                                                        >
                                                          <Checkbox
                                                            sx={{
                                                              pointerEvents:
                                                                'none',
                                                            }}
                                                            defaultChecked={
                                                              customField?.value
                                                            }
                                                          />
                                                        </Typography>
                                                      )}
                                                      {customField?.column
                                                        ?.type === 'text' && (
                                                        <Typography>
                                                          <Box
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                              customField?.value,
                                                            }}
                                                          ></Box>
                                                        </Typography>
                                                      )}
                                                      {customField?.column
                                                        ?.type === 'driver' && (
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 'bold',
                                                          }}
                                                        >
                                                          {
                                                            customField?.value
                                                              ?.name
                                                          }
                                                        </Typography>
                                                      )}
                                                    </Stack>
                                                  );
                                                }
                                              )}
                                            </>
                                          ):(
                                            <>
                                            </>
                                          )}




                                        </Stack>
                                      </div>
                                      {readonly ? (
                                       <></>
                                      ) : (
                                        <Switch
                                          checked={checked[`${providerModifications?.id}`]}
                                          onChange={(event, checkedRow) => {
                                            setChecked({...checked,[`${providerModifications?.id}`]: checkedRow });
                                            onChangeCheck(providerModifications?.id, checkedRow);
                                          }}
                                        />
                                      )}
                                    </Stack>
                                    <Box>
                                      <TextField
                                        fullWidth
                                        label="Message to Provider"
                                        multiline
                                        maxRows={4}
                                        onChange={(e) => onChangeMessage(providerModifications?.id, e.target.value)}
                                      />
                                    </Box>
                                  </Stack>
                                </React.Fragment>
                              }
                            />
                          </ListItem>
                        </List>
                      </>
                    );
                  }
                )}
              </React.Fragment>
            }
          />
        </ListItem>
      </ListItem>
    </>
  );
};